// Module
var code = `<div appHeaderBar><header-bar-title>Frequently Asked Questions</header-bar-title></div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="HOA-container HOA-container--border-tb">
        <div class="HOA-container__header">
            <h1 tid="pageTitle" id="pageTitle" class="HOA-container__header-text">Frequently Asked Questions</h1>
        </div>
        <div class="HOA-container__content HOA-container__content--legal">
            <div>
                <div tid="oneTimePaymentSection" id="oneTimePaymentSection" class="HOA-page-faq__header"
                     (click)="oneTimePayment = !oneTimePayment">
                    <button class="HOA-page-faq__header-button HOA-flex-component HOA-flextable-component__space-between">
                        <div tid="oneTimePaymentLabel" id="oneTimePaymentLabel" class="HOA-page-faq__header-text">
                            One-Time Payments
                        </div>
                        <div class="HOA-container__header-action">
                            <span tid="oneTimePaymentHide" id="oneTimePaymentHide" *ngIf="!oneTimePayment" class="Field--inline Icon Icon--18">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                                    <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                          stroke-linejoin="round" stroke-miterlimit="10"
                                          d="M62 22.48L36.008 49.52 10 22.48">
                                    </path>
                                </svg>
                            </span>
                            <span tid="oneTimePaymentShow" id="oneTimePaymentShow" *ngIf="oneTimePayment" class="Field--inline Icon Icon--18">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                                    <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                          stroke-linejoin="round" stroke-miterlimit="10"
                                          d="M10 49.52l25.992-27.04L62 49.52">
                                    </path>
                                </svg>
                            </span>
                        </div>
                    </button>
                </div>
                <div tid="oneTimePayment" id="oneTimePayment"
                     class="HOA-page-faq__header-content HOA-container__content--borderNone" *ngIf="oneTimePayment">
                    <h8><u>How do I make a one-time payment?</u></h8><br>
                    <h8>1. Log into your profile or select the Pay Assessments option on the home page</h8><div></div>
                    <h8>2. Select the Properties tab in the top right corner of the page</h8><div></div>
                    <h8>3. Identify the property that you would like to make a payment on</h8><div></div>
                    <h8>4. Select the Make a Payment box listed next to the property</h8><div></div>
                    <h8>5. Complete the Payment Information and enter the amount you want to pay</h8><div></div>
                    <h8>6. Select the Submit button</h8><div></div>
                    <h8>7. Review and confirm your payment by selecting the confirm button</h8><br>
                    <h8><u>Why would I need to make a one-time payment?</u></h8><br>
                    <h8>There are several reasons you may want to select the one-time payment option. Use the
                        one-time payment option for:
                    </h8><br>
    <li>Unexpected fees or dues</li>
    <li>One-time assessments</li>
    <li>Annual fees</li><br>
    <h8><u>When will my payment be processed?</u></h8><br>
    <h8>Payments are processed Monday through Friday (excluding holidays). Payments are processed at
        8 p.m. (CT). Payments submitted after 8:00 p.m. CT will be processed the next bank-business
        day. Payments made after 8 p.m. will be sent to your management company the next
        bank-business day. If your payment schedule falls on a holiday or weekend it will be
        processed on the business day before the weekend or holiday.
    </h8><br>
    </div>
    </div>
    <div class="HOA-page-faq__line-container">
        <div tid="managingPropertiesSection" id="managingPropertiesSection"
             class="HOA-page-faq__header HOA-flex-component"
             (click)="managingProperties = !managingProperties">
            <button class="HOA-page-faq__header-button HOA-flex-component HOA-flextable-component__space-between">
                <div tid="managingPropertiesLabel" id="managingPropertiesLabel"
                     class="HOA-page-faq__header-text">Managing Properties
                </div>
                <div class="HOA-container__header-action">
                    <span tid="managingPropertiesHide" id="managingPropertiesHide" *ngIf="!managingProperties" class="Field--inline Icon Icon--18">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                            <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-miterlimit="10"
                                  d="M62 22.48L36.008 49.52 10 22.48">
                            </path>
                        </svg>
                    </span>
                    <span tid="managingPropertiesShow" id="managingPropertiesShow" *ngIf="managingProperties" class="Field--inline Icon Icon--18">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                            <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-miterlimit="10"
                                  d="M10 49.52l25.992-27.04L62 49.52">
                            </path>
                        </svg>
                    </span>
                </div>
            </button>
        </div>
        <div tid="managingProperties" id="managingProperties" class="HOA-page-faq__header-content HOA-container__content--borderNone" *ngIf="managingProperties">
            <h8><u>How do I add properties?</u></h8><br>
            <h8>1. Log into your profile and click the Properties tab in the top right corner of the page</h8><div></div>
            <h8>2. Select the Add Property button located in the middle of the page</h8><div></div>
            <h8>3. Fill in the required information – You can choose to enter the Property Address or the
                Property IDs
            </h8><div></div>
            <h8>4. Once the information is filled out, click the Find My Property button</h8><div></div>
            <h8>5. If your property cannot be found, please contact your management company</h8><br>
            <h8><u>How do I delete properties?</u></h8><br>
            <h8>1. Log into your profile and click the Properties tab in the top right corner of the page</h8><div></div>
            <h8>2. Select the property that you would like to delete by clicking on the address</h8><div></div>
            <h8>3. Navigate to the bottom of the page and click the Delete Property button, located in the
                bottom middle of the page
            </h8><div></div>
            <h8>4. Select Yes to confirm that you would like to delete the property</h8><br>
            <h8><u>How do I edit information for properties?</u></h8><br>
            <h8>1. Log into your profile and click the Properties tab in the top right corner of the page</h8><div></div>
            <h8>2. Select the property that you would like to edit by clicking on the address</h8><div></div>
            <h8>3. You may edit the information that you would like by clicking in the property field</h8><br>
            <h8><u>What is the property account #?</u></h8><br>
            <h8>Your Property Account Number is an account number assigned to you by your Property
                Management Company. Your Property Account Number identifies you and your property. Please
                contact your Management Company if you require further information.
            </h8><br>
            <h8><u>What if I can’t find my property?</u></h8><br>
            <h8>Double check to make sure that your information is filled in correctly. If your property is
                still not able to be found, contact your Management Company to ensure your information is
                accurate or re-register your property in the Sign-Up page.
            </h8><br>
        </div>
    </div>
    <div class="HOA-page-faq__line-container">
        <div tid="managingPaymentsSection" id="managingPaymentsSection" class="HOA-page-faq__header"
             (click)="managingPayments = !managingPayments">
            <button class="HOA-page-faq__header-button HOA-flex-component HOA-flextable-component__space-between">
                <div tid="managingPaymentsLabel" id="managingPaymentsLabel"
                     class="HOA-page-faq__header-text">Managing Payments
                </div>
                <div class="HOA-container__header-action">
                    <span tid="managingPaymentsHide" id="managingPaymentsHide" *ngIf="!managingPayments" class="Field--inline Icon Icon--18">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                            <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-miterlimit="10"
                                  d="M62 22.48L36.008 49.52 10 22.48">
                            </path>
                        </svg>
                    </span>
                    <span tid="managingPaymentsShow" id="managingPaymentsShow" *ngIf="managingPayments" class="Field--inline Icon Icon--18">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                            <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-miterlimit="10"
                                  d="M10 49.52l25.992-27.04L62 49.52">
                            </path>
                        </svg>
                    </span>
                </div>
            </button>
        </div>
        <div tid="managingPayments" id="managingPayments" class="HOA-page-faq__header-content HOA-container__content--borderNone" *ngIf="managingPayments">
            <h8><u>Do I need to sign in to make a payment?</u></h8><br>
            <h8>You do not need to sign in to make a payment. If you would like, you can make a one-time
                payment as a guest by selecting the Pay Assessments button on the Home Screen. If you use
                this method, you will need to enter your property and payment information.
            </h8><br>
            <h8><u>How do I manage my payment accounts?</u></h8><br>
            <h8>You can manage your payment accounts within your wallet. From your wallet you can add,
                delete, and edit your payment accounts.
            </h8><br>
            <h8><u>How do I create scheduled payments?</u></h8><br>
            <h8>1. Log into your profile and the property you want to create a schedule for</h8><div></div>
            <h8>2. Select Scheduled Payments</h8><div></div>
            <h8>3. Enter your payment information</h8><div></div>
            <h8>4. Select the frequency of your payment schedule</h8><div></div>
            <h8>5. Enter the amount that you want to pay and select Continue</h8><br>
            <h8><u>Are fees applied for card payments?</u></h8><br>
            <h8>Administrative fees may be included in payments. The administrative fee is indicated in the Total
                Amount Field on the payment page.
            </h8><br>
            <h8><u>Why can't I make a payment?</u></h8><br>
            <h8>If you are experiencing errors making a payment, please contact First Citizens Bank at (866) 800-4656 option 3 or <a tid="emailLink" id="emailLink" href="mailto:servicepropertypay@firstcitizens.com">servicepropertypay@firstcitizens.com</a></h8>
            <br>
            <h8><u>How do I cancel a payment schedule?</u></h8><br>
            <h8>If you wish to cancel a payment schedule:</h8>
            <p></p>
            <h8>1. Log into your profile and select the Properties tab in the top right corner of the page</h8><div></div>
            <h8>2. Select the payment schedule you wish to edit found under the Scheduled Payments section</h8><div></div>
            <h8>3. At the bottom of the page, select Delete Schedule to delete the entire payment schedule</h8><div></div>
            <h8>4. Edit the payment schedule by selecting the Edit Schedule Details button</h8><br>
            <h8><u>Can I schedule payments using multiple payment methods?</u></h8><br>
            <h8>No, you are only able to use one payment method per payment schedule. You are able, however,
                to create multiple payment schedules using different payment methods for each one if you
                wish to do so.
            </h8>
            <br>
        </div>
    </div>
    <div class="HOA-page-faq__line-container">
        <div tid="managingWalletSection" id="managingWalletSection" class="HOA-page-faq__header" (click)="managingWallet = !managingWallet">
            <button class="HOA-page-faq__header-button HOA-flex-component HOA-flextable-component__space-between">
                <div tid="managingWalletLabel" id="managingWalletLabel" class="HOA-page-faq__header-text">
                    Managing My Wallet
                </div>
                <div class="HOA-container__header-action">
                    <span tid="managingWalletHide" id="managingWalletHide" *ngIf="!managingWallet" class="Field--inline Icon Icon--18">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                            <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-miterlimit="10"
                                  d="M62 22.48L36.008 49.52 10 22.48">
                            </path>
                        </svg>
                    </span>
                    <span tid="managingWalletShow" id="managingWalletShow" *ngIf="managingWallet" class="Field--inline Icon Icon--18">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                            <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-miterlimit="10"
                                  d="M10 49.52l25.992-27.04L62 49.52">
                            </path>
                        </svg>
                    </span>
                </div>
            </button>
        </div>
        <div tid="managingWallet" id="managingWallet"
             class="HOA-page-faq__header-content HOA-container__content--borderNone" *ngIf="managingWallet">
            <h8><u>What is My Wallet?</u></h8><br>
            <h8>My Wallet is a collection of your payment types including credit cards, debit cards, and
                bank accounts. You can use this feature to store and select your payment methods.
            </h8><br>
            <h8><u>How do I add a payment method?</u></h8><br>
            <h8>1. Select Wallet in the top right corner of the page</h8><div></div>
            <h8>2. Select either add a card or a bank account</h8><div></div>
            <h8>3. To add a card, click Add Card</h8><div></div>
            <h8>4. Enter the card information and select Add Card</h8><div></div>
            <h8>5. To add a bank account, select Add Bank Account next to the Bank Account subtitle</h8><div></div>
            <h8>6. Enter the bank account information and select the Add Bank Account button</h8><br>
            <h8><u>How many payment methods can I have?</u></h8><br>
            <h8>You can have as many payment methods as you deem necessary. See the question above to learn
                how to add a payment method.
            </h8><br>
            <h8><u>Can I add a temporary payment method?</u></h8><br>
            <h8>There is not an option to add a temporary payment method. If you wish to use a payment
                method more than once, add the payment method to your wallet. Payment methods can be deleted
                from your wallet at any time. The One-Time payment option allows you to use whichever
                payment method you prefer for that One-Time payment.
            </h8><br>
            <h8><u>What payment forms can be used?</u></h8><br>
            <h8>The following payment forms can be used: Card (Mastercard® Visa®, Discover®, and American
                Express®), and eCheck payments with a valid bank account number and bank routing number.
            </h8><br>
            <h8><u>How do I delete a payment method?</u></h8><br>
            <h8>1. If you wish to delete a payment method, select Wallet in the top right corner of the
                page
            </h8><div></div>
            <h8>2. Select the name of the card or bank account that you want to delete</h8><div></div>
            <h8>3. Click on Delete Payment Method located at the bottom of the page to delete the payment
                method
            </h8><br>
        </div>
    </div>
    <div class="HOA-page-faq__line-container">
        <div tid="myAccountSection" id="myAccountSection" class="HOA-page-faq__header"
             (click)="myAccount = !myAccount">
            <button class="HOA-page-faq__header-button HOA-flex-component HOA-flextable-component__space-between">
                <div tid="myAccountLabel" id="myAccountLabel" class="HOA-page-faq__header-text">My Account
                </div>
                <div class="HOA-container__header-action">
                    <span tid="myAccountHide" id="myAccountHide" *ngIf="!myAccount" class="Field--inline Icon Icon--18">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                            <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-miterlimit="10"
                                  d="M62 22.48L36.008 49.52 10 22.48">
                            </path>
                        </svg>
                    </span>
                    <span tid="myAccountShow" id="myAccountShow" *ngIf="myAccount" class="Field--inline Icon Icon--18">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                            <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-miterlimit="10"
                                  d="M10 49.52l25.992-27.04L62 49.52">
                            </path>
                        </svg>
                    </span>
                </div>
            </button>
        </div>
        <div tid="myAccount" id="myAccount" class="HOA-page-faq__header-content HOA-container__content--borderNone" *ngIf="myAccount">
            <h8><u>What is an Association ID?</u></h8><br>
            <h8>An Association ID is the ID assigned to your Homeowner's Association. Your Association ID
                can be located on the bottom of your payment remittance coupon or statement. If you are
                unable to locate it, please contact your Homeowner's Association. Or, you can search for
                your property by address.
            </h8><br>
            <h8><u>What is a Management Company ID?</u></h8><br>
            <h8>A Management Company ID is the ID assigned to your Homeowner's Association. Your Management
                Company ID can be located on the bottom of your payment remittance coupon or statement. If
                you cannot find it, please contact your Homeowner's Association. Or, you can search for your
                property by address.
            </h8><br>
            <h8><u>How do I register a profile?</u></h8><br>
            <h8>1. To register a profile, select Sign-Up on the Property Pay Welcome Page</h8><div></div>
            <h8>2. Provide the required information and select continue</h8><div></div>
            <h8>3. Once you are registered, you will have the ability to add payment methods, set up a
                payment schedule, and add additional properties to your account
            </h8><br>
            <h8><u>What if I forget my password?</u></h8><br>
            <h8>1. Select Forgot Your Password at the bottom of the login page</h8><div></div>
            <h8>2. Enter your username or email address</h8><div></div>
            <h8>3. A 6-digit verification code will be sent to your email</h8><div></div>
            <h8>4. Enter the verification code in the box</h8><div></div>
            <h8>5. At this time, you can change your password</h8><br>
            <h8><u>How do I change my email address?</u></h8><br>
            <h8>1. If you wish to change your email address, select More in the drop-down arrow at the top
                right corner of the page
            </h8><div></div>
            <h8>2. Select My Account</h8><div></div>
            <h8>3. Select Edit, located next to your email address</h8><div></div>
            <h8>4. Enter your new email address, then select Update</h8><br>
        </div>
    </div>
    <div class="HOA-page-faq__line-container">
        <div tid="otherSection" id="otherSection" class="HOA-page-faq__header" (click)="other = !other">
            <button class="HOA-page-faq__header-button HOA-flex-component HOA-flextable-component__space-between">
                <div tid="otherLabel" id="otherLabel" class="HOA-page-faq__header-text">Other</div>
                <div class="HOA-container__header-action">
                    <span tid="otherHide" id="othertHide" *ngIf="!other" class="Field--inline Icon Icon--18">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                            <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-miterlimit="10"
                                  d="M62 22.48L36.008 49.52 10 22.48">
                            </path>
                        </svg>
                    </span>
                    <span tid="otherShow" id="otherShow" *ngIf="other" class="Field--inline Icon Icon--18">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                            <path fill="none" stroke="#007255" stroke-width="4.6" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-miterlimit="10"
                                  d="M10 49.52l25.992-27.04L62 49.52">
                            </path>
                        </svg>
                    </span>
                </div>
            </button>
        </div>
        <div tid="other" id="other" class="HOA-page-faq__header-content HOA-container__content--borderNone"
             *ngIf="other">
            <h8><u>How do I contact my Homeowners Association (HOA)?</u></h8>
            <br>
            <h8>The name of your Homeowner Association is above your property address. However, you can also
                contact your Property Management Company for assistance.
            </h8>
            <br>
            <h8><u>How do I contact my Property Management Company (PMC)?</u></h8>
            <br>
            <h8>Under the address of your property, there is a link to the communication details of your
                property management company. They provide support to your Homeowner Association.
            </h8>
            <br>
            <h8><u>How do I contact First Citizens Bank?</u></h8>
            <br>
            <h8>You can contact us by:</h8>
            <br>
    <li>Phone: (866) 800-4656 option 3</li>
    <li>Email: <a tid="emailLink" id="emailLink" href="mailto:servicepropertypay@firstcitizens.com">servicepropertypay@firstcitizens.com</a></li>
    <li>Website: <a tid="websiteLink" id="websiteLink" href=""
                    (click)="openUrl('https://www.firstcitizens.com/hosted/community-association-banking-customer-support')">
            firstcitizens.com/cab
        </a>
    </li>
    <br>
    <h8><u>How do I look up transaction history?</u></h8>
    <br>
    <h8>Your payment history is displayed in the Properties tab, beneath the property address. You
        can select the View All button to view all of your prior payments.
    </h8>
    <br>
    <h8><u>What is the administrative fee? Do I have to pay it?</u></h8>
    <br>
    <h8>The administrative fee is a transaction fee charged for First Citizens Bank and your Property Management
        Company to process transactions. You are required to pay this fee, as it covers the costs of
        the transaction process.
    </h8>
    </div>
    </div>
    </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;